import React, {useEffect, useState} from 'react';
import {useKeycloak} from "@react-keycloak/web";
import {PaymentService} from "../services/PaymentService";
import {Box, Button, Checkbox, FormControlLabel, TextField, ToggleButton, ToggleButtonGroup, Typography} from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';
import {ProvidersService} from "../services/ProvidersService";
import {useNavigate} from "react-router-dom";
import SearchResult from "../components/SearchResult";
import {UserService} from "../services/UserService";
import {Helmet} from "react-helmet";

const textBoxStyle = {paddingLeft: "15px", paddingRight: "15px", marginTop: "5px", marginBottom: "5px", maxWidth: "calc(100vw - 30px)"};
const BookAppointment = () => {
    const [bookingData, setBookingData] = useState(JSON.parse(localStorage.getItem("bookingData")));
    const {keycloak} = useKeycloak();
    const [transaction, setTransaction] = useState();
    const [provider, setProvider] = useState();
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [countDown, setCountDown] = useState(null);
    const [expiryTime, setExpiryTime] = useState(null);
    const [booked, setBooked] = useState(false);
    const [expired, setExpired] = useState(false);
    const [appointmentLength] = useState(calculateAppointmentLengthString());
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [policiesAgreed, setPoliciesAgreed] = useState(false);

    PaymentService.keycloak = keycloak;
    async function StartTransaction() {
        if (keycloak.authenticated) {
            try {
                let response = await UserService.getUserProfile();
                if (response && response.status === 404) {
                    navigate('/userProfile?redirectTo=/bookAppointment');

                }
                else if (response && response.status === 200) {
                    if (bookingData)
                        PaymentService.startTransaction(bookingData?.providerId,
                            keycloak?.tokenParsed?.sub,
                            bookingData?.selectedService?.name,
                            bookingData?.selectedLength?.length,
                            bookingData?.appointment,
                            undefined,
                            bookingData?.schedulingSlotId)
                            .then((t) => {
                                localStorage.setItem("currentTransactionId", JSON.stringify(t?.id));
                                setTransaction(t);
                                ProvidersService.getSingleProvider(t?.providerId).then((p) => {
                                    setProvider(p);
                                })
                            });
                }
                else
                {
                    console.error("Error while starting transaction");
                }
            }
            catch (error) {
                if(error?.response?.status === 404) {
                    navigate('/userProfile?redirectTo=/bookAppointment');
                }
                else {
                    console.error(error);
                }
            }
        }
    }

    function calculateAppointmentLengthString() {
        const length = bookingData?.selectedLength?.length;
        const hourString = length<120?"Hour":"Hours";
        const minuteString = length<2?"Minute":"Minutes";
        const displayHour = length>=60;
        const displayMinute = length%60>0;

        if (!displayHour){
            return `${length} ${minuteString}`
        } else {
            return `${~~(length / 60)} ${hourString} ${displayMinute ? (~~(length % 60)).toString() + " " + minuteString : ""}`
        }
    }

    useEffect(() => {
        if(provider?.stripeAccepted)
        {
            setPaymentMethod("Stripe");
        }
        else if(provider?.cashAccepted)
        {
            setPaymentMethod("Cash");
        }
    }, [provider]);

    useEffect(() => {
        setExpired(countDown !== null && countDown < 1);
    }, [countDown])

    useEffect(() => {
            window.scrollTo(0,0);
            let currentTransactionId
            try {
                currentTransactionId = JSON.parse(localStorage.getItem("currentTransactionId"));
            } catch (e) {//ignore
            }

            if (currentTransactionId) {
                PaymentService.getTransaction(currentTransactionId).then((t) => {
                    if (t.transactionStatus === "Started") {
                        setTransaction(t);
                        ProvidersService.getSingleProvider(t?.providerId).then((p) => {
                            setProvider(p);
                        })
                    } else {
                        localStorage.setItem("currentTransactionId", null)
                        StartTransaction();
                    }
                })
            } else {
                StartTransaction();
            }
        }
        ,
        []
    )

    useEffect(() => {
        if (transaction) {
            let t = new Date(new Date(transaction?.startTime).getTime() + 5 * 60000);
            setExpiryTime(t);
            setCountDown(~~((t - new Date()) / 1000));

            const interval = setInterval(() => {
                setCountDown(countDown => countDown - 1);
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [transaction])

    const completeBooking = () => {
        PaymentService.completeTransaction(transaction?.id, paymentMethod, window.location.origin).then((t) => {
            console.log(t);
            if (t?.transactionStatus === 'Completed') {
                setBookingData(undefined);
                localStorage.setItem("bookingData", null);
                setBooked(true);
            } else if (t?.object === 'payment_link') {
                window.location = t.url;
            }
            else {
                //this is an error
                setError("There was a problem while booking your appointment. Please refresh the page and try again.");
            }
        }).catch(() => {
            setError("There was a problem while booking your appointment. Please refresh the page and try again.");
        });
    }

    const cancelBooking = () => {
        PaymentService.cancelTransaction(transaction?.id).then(() => {
                setBookingData(undefined);
                localStorage.setItem("bookingData", null);
                navigate("/");
        });
    }

    const hasPolicies = !!(provider?.cancellationPolicy || provider?.lateArrivalPolicy);

    return (
        <Box sx={{minHeight: "600px"}}>
            <Helmet>
                <title>PairCare - Book Appointment</title>
            </Helmet>
            {bookingData && !error && !expired && <Box>
                <Box sx={{marginLeft: "auto", marginRight: "auto", display: "table", textAlign: "center"}}>
                    <Typography fontSize={"16pt"}>Good news! We're holding your spot
                        until {expiryTime?.toLocaleString()}</Typography>
                    <br/>
                    <Typography fontSize={"22pt"} fontWeight={"bold"}>Booking Details</Typography>
                </Box>

                <Box sx={{
                    marginLeft: "auto",
                    marginRight: "auto",
                    display: "table",
                    textAlign: "center",
                    maxWidth: "600px"
                }}>
                    {/*                   <Table>
                        <TableRow><TableCell>asdf</TableCell><TableCell>fdsa</TableCell></TableRow>
                    </Table>*/}
                    <Box maxWidth={"600px"}>
                        {provider && <SearchResult item={provider} isBookingPage={true} isLast={true} maxWidth={600} k={0}/>}
                    </Box>

                    {bookingData?.selectedService && <TextField
                        sx={textBoxStyle}
                        label="Service"
                        defaultValue={bookingData?.selectedService?.name}
                        InputProps={{
                            readOnly: true,
                        }}
                        fullWidth={true}
                    />}
                    {bookingData && <TextField
                        sx={textBoxStyle}
                        label="Appointment Time"
                        defaultValue={(bookingData?.appointment) && (new Date(bookingData?.appointment)).toLocaleString()}
                        InputProps={{
                            readOnly: true,
                        }}
                        fullWidth={true}
                    />}
                    {bookingData?.selectedLength && <TextField
                        sx={textBoxStyle}
                        label="Appointment Length"
                        defaultValue={appointmentLength}
                        InputProps={{
                            readOnly: true,
                        }}
                        fullWidth={true}
                    />}
                    {provider && <TextField
                        sx={textBoxStyle}
                        label="Total"
                        defaultValue={"$" + (transaction?.amount).toFixed(2)}
                        InputProps={{
                            readOnly: true,
                        }}
                        fullWidth={true}
                    />}
                    {provider && provider?.cashAccepted && provider?.stripeAccepted && <ToggleButtonGroup sx={{
                        maxWidth: "calc(100vw - 30px)",
                        paddingLeft: "15px", paddingRight: "15px",
                        marginTop: "5px", marginBottom: "5px",
                        marginLeft: "auto", marginRight:"auto"}}
                        value={paymentMethod}>
                        {provider?.cashAccepted && <ToggleButton value="Cash" onClick={()=> setPaymentMethod("Cash")}>Pay Later</ToggleButton>}
                        {provider?.stripeAccepted && <ToggleButton value="Stripe" onClick={()=> setPaymentMethod("Stripe")}>Pay Now</ToggleButton>}
                    </ToggleButtonGroup>
                    }
                </Box>
                {hasPolicies && (
                    <Box sx={{
                        marginLeft: "auto",
                        marginRight: "auto",
                        marginTop: "20px",
                        maxWidth: "600px",
                        padding: "15px",
                        border: "1px solid rgba(0,0,0,0.12)",
                        borderRadius: "8px",
                        background: "#fafafa",
                        textAlign: "left"
                    }}>
                        <Typography fontWeight={"bold"} sx={{marginBottom: "8px"}}>Provider Policies</Typography>
                        {provider?.cancellationPolicy && (
                            <Box sx={{marginBottom: "10px"}}>
                                <Typography fontWeight={"medium"} fontSize={"0.9rem"}>Cancellation Policy</Typography>
                                <Typography fontSize={"0.85rem"} style={{whiteSpace: "pre-wrap"}}>{provider.cancellationPolicy}</Typography>
                            </Box>
                        )}
                        {provider?.lateArrivalPolicy && (
                            <Box sx={{marginBottom: "10px"}}>
                                <Typography fontWeight={"medium"} fontSize={"0.9rem"}>Late Arrival Policy</Typography>
                                <Typography fontSize={"0.85rem"} style={{whiteSpace: "pre-wrap"}}>{provider.lateArrivalPolicy}</Typography>
                            </Box>
                        )}
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={policiesAgreed}
                                    onChange={(e) => setPoliciesAgreed(e.target.checked)}
                                />
                            }
                            label="I have read and agree to the provider's policies above."
                        />
                    </Box>
                )}
                <Box>
                <Typography style={{margin: "10px", marginTop: "50px", fontSize: "small", textAlign: "justify", fontStyle: "italic"}}>
                    <strong>Disclaimer:</strong> By proceeding with this booking,
                    you acknowledge and agree that it is made exclusively with
                    an independent third-party provider, which bears sole
                    responsibility for delivering the services.
                    PairCare.ai, Pair Tech LLC, and all subsidiaries
                    (collectively &quot;we&quot; or &quot;us&quot;) are not involved in providing or
                    administering these services and do not guarantee the quality,
                    availability, or fulfillment of any third-party services.
                    Any questions, concerns, or claims regarding the services must be
                    directed to the third-party provider. We disclaim all liability
                    arising out of or related to these third-party services.
                </Typography>
                </Box>
                <Box sx={{
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: "15px",
                    marginBottom: "50px",
                    display: "table",
                    textAlign: "center"
                }}>
                    <Button sx={{margin: "5px"}} onClick={cancelBooking} startIcon={<CancelIcon />} color={"error"}
                            variant="contained"> | {~~(countDown / 60)}:{(~~(countDown % 60)).toString().padStart(2, 0)}
                    </Button>
                    <Button sx={{margin: "5px", backgroundColor: '#f97316', '&:hover': { backgroundColor: '#ea670c' }}} onClick={completeBooking}
                            variant="contained"
                            disabled={hasPolicies && !policiesAgreed}>
                        <Typography>Complete Booking</Typography>
                    </Button>
                </Box>
            </Box>}
            {error && <Box sx={{
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: "15px",
                display: "table",
                textAlign: "center"
            }}>
                <Typography>{error}</Typography>
                <Button onClick={() => {
                    window.location.reload()
                }}>Refresh</Button>
            </Box>}
            {booked && <Box sx={{textAlign: "center"}}>
                <Typography fontSize={"18pt"}>Thank you for booking with PairCare.ai</Typography>
                <Typography fontSize={"18pt"}>You will receive an email with the reservation
                    details.</Typography>
                <Button onClick={() => {
                    navigate("/");
                }}>Click Here To Continue Browsing</Button>
            </Box>}
            {expired && (bookingData) && !error && <Box sx={{textAlign: "center"}}>
                <Typography fontSize={"18pt"} sx={{margin:"10px"}}>Timed Out</Typography>
                <br/>
                <Typography fontSize={"14pt"} sx={{margin:"10px"}}>We may be able to get the same appointment for you again. If you
                    are still interested, just click the button below.</Typography>
                <Button onClick={() => {
                    window.location.reload()
                }}>Click Here If You Are Still Interested And Want To Try Again</Button>
                <Button onClick={() => {
                    setBookingData(undefined);
                    localStorage.setItem("bookingData", null);
                    localStorage.setItem("currentTransactionId", null);
                    navigate("/");
                }}>Click Here To Continue Browsing</Button>
            </Box>}

            {!(bookingData) && !error && !booked && <Box sx={{textAlign: "center"}}>
                <Typography fontSize={"14pt"} sx={{margin:"10px"}}>Doesn't look like you've selected anything to be booked
                    yet.</Typography>
                <Button onClick={() => {
                    navigate("/");
                }}>Click Here To Continue Browsing</Button>
            </Box>}

        </Box>
    )
}

export default BookAppointment;
